import React from 'react';
/**
 * We can't export a generic type from a module, so we need to cast the context to the correct type when we use it.
 *
 * Example: {@link useFormContext}
 */
const FormContext = /*#__PURE__*/React.createContext({});
export const useFormContext = () => {
  const formContext = React.useContext(FormContext);
  if (!formContext) {
    throw new Error('useFormContext must be used within a FormContext.Provider');
  }
  return formContext;
};
export default FormContext;
//# sourceMappingURL=FormContext.js.map